<template>
  <component
    :is="randomScribble"
    :style="{
      strokeDasharray: length,
      strokeDashoffset: length,
      animationDuration: `${duration}s`,
      animationDelay: `${delay}s`,
      transform: `translate(-50%, -50%) rotate(${rotate * 360}deg) scaleX(${scaleX > 0.5 ? 1 : -1}) scaleY(${scaleY > 0.5 ? 1 : -1})`,
      top: `${top * 100}%`,
      left: `${left * 100}%`
    }"
    :class="{'red-stroke':  redStroke}"
    class="scribble"
    />
      <!-- strokeWidth: `${(1920 - viewPort.width) * 0.01}px`, -->
</template>

<script>
import { Viewport } from '@monogrid/vue-lib'

import delay from 'lodash/delay'
import line01 from '@/assets/img/lines/line01.svg'
import line02 from '@/assets/img/lines/line02.svg'
import line03 from '@/assets/img/lines/line03.svg'
import line04 from '@/assets/img/lines/line04.svg'
// import line05 from '@/assets/img/lines/line05.svg'

export default {
  name: 'RandomScribble',
  mixins: [Viewport],
  props: {
    redStroke: {
      required: false,
      type: Boolean,
      default: false
    },
    x: {
      required: false,
      type: Number,
      default: -1
    },
    y: {
      required: false,
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      scribbles: [
        line01,
        line02,
        line03,
        line04
        // line05
      ],
      randomScribble: null,
      length: 0,
      duration: 0,
      rotate: 0,
      scaleX: 1,
      scaleY: 1,
      top: 0,
      left: 0,
      delay: 0
      // redStroke: false
    }
  },
  created () {
    // console.log('created')
    this.randomScribble = this.scribbles[Math.floor(Math.random() * this.scribbles.length)]
    this.top = this.x !== -1 ? this.x : Math.random()
    this.left = this.y !== -1 ? this.y : Math.random()
    this.rotate = Math.random()
    this.scaleX = Math.random()
    this.scaleY = Math.random()
    this.delay = Math.random() * 2
    // this.redStroke = Math.random() > 0.7
  },
  mounted () {
    this.calcLength()
  },
  updated () {
    this.calcLength()
  },
  methods: {
    calcLength () {
      if (this.length === 0) {
        if (!this.$el) {
          delay(this.calcLength, 10)
          return
        }
        const elements = this.$el.getElementsByTagName('path')
        if (elements.length === 0) {
          delay(this.calcLength, 10)
          return
        }
        elements.forEach(element => {
          this.length += element.getTotalLength()
        })

        this.duration = (this.length * 0.0005) + Math.random() * 2
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.scribble {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 100vh;
  height: 100vh;
  opacity: 0.2;

  animation-name: mydash;
  animation-fill-mode: forwards;
  animation-timing-function: $ease-in-quad;
  animation-iteration-count: 1;

  fill: none;
  shape-rendering: geometricPrecision;

  .ie11 & {
    animation-name: unset;

    path {
      stroke-dasharray: 0 !important;
      stroke-dashoffset: 0 !important;
    }
  }

  path {
    stroke: #202020 !important;
    stroke-width: 1.5px;
    vector-effect: non-scaling-stroke;
  }

  &.red-stroke {
    path {
      stroke: map-deep-get($colors, 'red', 'base') !important;
    }
  }
}

@keyframes mydash {
  to {
    stroke-dashoffset: 0;
  }
}

</style>
